// extracted by mini-css-extract-plugin
export default {"labelWidthSecondaryTextJobExpiresSoon":"_5Ita"};